export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const REGISTER = 'REGISTER';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const VERIFY = 'VERIFY';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAIL = 'VERIFY_FAIL';

export const FORGOTPASSWORD = 'FORGOTPASSWORD';
export const FORGOTPASSWORD_SUCCESS = 'FORGOTPASSWORD_SUCCESS';
export const FORGOTPASSWORD_FAIL = 'FORGOTPASSWORD_FAIL';

export const RESET = 'RESET';
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const RESET_FAIL = 'RESET_FAIL';

export const CLEAR_FROM = 'CLEAR_FROM';
export const CLEAR_ADD = 'CLEAR_ADD';
export const CLEAR_REQUEST = 'CLEAR_REQUEST';
export const GET_LOCATION = 'GET_LOCATION';
export const GET_LOCATION_DETAILS = 'GET_LOCATION_DETAILS';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAIL = 'UPDATE_PROFILE_FAIL';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAIL = 'REFRESH_TOKEN_FAIL';

export const GET_PRODUCT = 'GET_PRODUCT';
export const LOADING_PRODUCT = 'LOADING_PRODUCT';
export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAIL = 'GET_PRODUCTS_FAIL';

export const GET_PRODUCTS_BY_CATEGORY = 'GET_PRODUCTS_BY_CATEGORY';
export const GET_PRODUCTS_BY_CATEGORY_SUCCESS = 'GET_PRODUCTS_BY_CATEGORY_SUCCESS';
export const GET_PRODUCTS_BY_CATEGORY_FAIL = 'GET_PRODUCTS_BY_CATEGORY_FAIL';

export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAIL = 'GET_CATEGORIES_FAIL';

export const GET_CATEGORY_DETAILS = 'GET_CATEGORY_DETAILS';
export const GET_CATEGORY_DETAILS_SUCCESS = 'GET_CATEGORY_DETAILS_SUCCESS';
export const GET_CATEGORY_DETAILS_FAIL = 'GET_CATEGORY_DETAILS_FAIL';

export const GET_CATEGORY_BY_ID = 'GET_CATEGORY_DETAILS';
export const GET_CATEGORY_BY_ID_SUCCESS = 'GET_CATEGORY_BY_ID_SUCCESS';
export const GET_CATEGORY_BY_ID_FAIL = 'GET_CATEGORY_BY_ID_FAIL';

export const CREATE_CART = 'CREATE_CART';
export const CREATE_CART_SUCCESS = 'CREATE_CART_SUCCESS';
export const CREATE_CART_FAIL = 'CREATE_CART_FAIL';

export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_CANCEL = 'ADD_TO_CART_CANCEL';
export const ADD_TO_CART_FAIL = 'ADD_TO_CART_FAIL';

export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_CART_SUCCESS = 'UPDATE_CART_SUCCESS';
export const UPDATE_CART_FAIL = 'UPDATE_CART_FAIL';

export const VIEW_CART_DETAILS = 'VIEW_CART_DETAILS';
export const VIEW_CART_DETAILS_SUCCESS = 'VIEW_CART_DETAILS_SUCCESS';
export const VIEW_CART_DETAILS_FAIL = 'VIEW_CART_DETAILS_FAIL';

export const REMOVE_FROM_CART = 'REMOVE_FORM_CART';
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FORM_CART_SUCCESS';
export const REMOVE_FROM_CART_FAIL = 'REMOVE_FORM_CART_FAIL';

export const ADD_SHIPPING_DETAILS = 'ADD_SHIPPING_DETAILS';
export const ADD_SHIPPING_DETAILS_SUCCESS = 'ADD_SHIPPING_DETAILS_SUCCESS';
export const ADD_SHIPPING_DETAILS_FAIL = 'ADD_SHIPPING_DETAILS_FAIL';

export const GET_SHIPPING_DETAILS = 'GET_SHIPPING_DETAILS';
export const GET_SHIPPING_DETAILS_SUCCESS = 'GET_SHIPPING_DETAILS_SUCCESS';
export const GET_SHIPPING_DETAILS_FAIL = 'GET_SHIPPING_DETAILS_FAIL';

export const GET_CART_DETAILS = 'GET_CART_DETAILS';
export const GET_CART_DETAILS_SUCCESS = 'GET_CART_DETAILS_SUCCESS';
export const GET_CART_DETAILS_FAIL = 'GET_CART_DETAILS_FAIL';

export const ADD_BILLING_ADDRESS = 'ADD_BILLING_ADDRESS';
export const ADD_BILLING_ADDRESS_SUCCESS = 'ADD_BILLING_ADDRESS_SUCCESS';
export const ADD_BILLING_ADDRESS_FAIL = 'ADD_BILLING_ADDRESS_FAIL';

export const PLACE_ORDER = 'PLACE_ORDER';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_FAIL = 'PLACE_ORDER_FAIL';

export const GET_WISHLIST = 'GET_WISHLIST';
export const GET_WISHLIST_SUCCESS = 'GET_WISHLIST_SUCCESS';
export const GET_WISHLIST_FAIL = 'GET_WISHLIST_FAIL';

export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const ADD_TO_WISHLIST_SUCCESS = 'ADD_TO_WISHLIST_SUCCESS';
export const ADD_TO_WISHLIST_FAIL = 'ADD_TO_WISHLIST_FAIL';

export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST';
export const REMOVE_FROM_WISHLIST_SUCCESS = 'REMOVE_FROM_WISHLIST_SUCCESS';
export const REMOVE_FROM_WISHLIST_FAIL = 'REMOVE_FROM_WISHLIST_FAIL';

export const DELETE_FROM_WISHLIST = 'DELETE_FROM_WISHLIST';
export const DELETE_FROM_WISHLIST_SUCCESS = 'DELETE_FROM_WISHLIST_SUCCESS';
export const DELETE_FROM_WISHLIST_FAIL = 'DELETE_FROM_WISHLIST_FAIL';

export const CREATE_STORE = 'CREATE_STORE';
export const CREATE_STORE_SUCCESS = 'CREATE_STORE_SUCCESS';
export const CREATE_STORE_FAIL = 'CREATE_STORE_FAIL';

export const GET_STORE = 'GET_STORE';
export const GET_STORE_SUCCESS = 'GET_STORE_SUCCESS';
export const GET_STORE_FAIL = 'GET_STORE_FAIL';

export const GET_ORDERED_PRODUCTS = 'GET_ORDERED_PRODUCTS';
export const GET_ORDERED_PRODUCTS_SUCCESS = 'GET_ORDERED_PRODUCTS_SUCCESS';
export const GET_ORDERED_PRODUCTS_FAIL = 'GET_ORDERED_PRODUCTS_FAIL';

export const ADD_TO_STORE = 'ADD_TO_STORE';
export const ADD_TO_STORE_SUCCESS = 'ADD_TO_STORE_SUCCESS';
export const ADD_TO_STORE_FAIL = 'ADD_TO_STORE_FAIL';
export const EDIT_STORE_PRODUCT = 'EDIT_STORE_PRODUCT';
export const CLEAR_STORE_ACTIONS = 'CLEAR_STORE_ACTIONS';

export const REMOVE_FROM_STORE = 'REMOVE_FROM_STORE';
export const REMOVE_FROM_STORE_SUCCESS = 'REMOVE_FROM_STORE_SUCCESS';
export const REMOVE_FROM_STORE_FAIL = 'REMOVE_FROM_STORE_FAIL';

export const GET_PRODUCT_STOCK = 'GET_PRODUCT_STOCK';
export const GET_PRODUCT_STOCK_SUCCESS = 'GET_PRODUCT_STOCK_SUCCESS';
export const GET_PRODUCT_STOCK_FAIL = 'GET_PRODUCT_STOCK_FAIL';

export const WALLET = 'WALLET';
export const WALLET_SUCCESS = 'WALLET_SUCCESS';
export const WALLET_FAIL = 'WALLET_FAIL';

export const ORDER = 'ORDER';
export const ORDER_SUCCESS = 'ORDER_SUCCESS';
export const ORDER_FAIL = 'ORDER_FAIL';

export const SINGLE_ORDER = 'SINGLE_ORDER';
export const SINGLE_ORDER_SUCCESS = 'SINGLE_ORDER_SUCCESS';
export const SINGLE_ORDER_FAIL = 'SINGLE_ORDER_FAIL';

export const INITIATE_PRODUCT_RETURN = 'INITIATE_PRODUCT_RETURN';
export const INITIATE_PRODUCT_RETURN_SUCCESS = 'INITIATE_PRODUCT_RETURN_SUCCESS';
export const INITIATE_PRODUCT_RETURN_FAIL = 'INITIATE_PRODUCT_RETURN_FAIL';

export const STOREFRONT_FETCH_STORE = 'STOREFRONT_FETCH_STORE';
export const LOADING_STOREFRONT = 'LOADING_STOREFRONT';
export const UPDATE_STORE_CART = 'UPDATE_STORE_CART';
export const REMOVE_FROM_STORE_CART = 'REMOVE_FROM_STORE_CART';

export const FETCH_BRANDS = 'FETCH_BRANDS';
export const LOADING_BRANDS = 'LOADING_BRANDS';
export const UPDATE_BRANDS = 'UPDATE_BRANDS';
export const FETCH_BRAND = 'FETCH_BRAND';
export const SELECT_VENDOR = 'SELECT_VENDOR';
export const SELECT_BRAND = 'SELECT_BRAND';

export const UPDATE_VARIANT_TABLE = 'UPDATE_VARIANT_TABLE';

export const CHECKOUT_CART = 'CHECKOUT_CART';
export const CHECKOUT_CART_SUCCESS = 'CHECKOUT_CART_SUCCESS';
export const CHECKOUT_CART_FAIL = 'CHECKOUT_CART_FAIL';
